export const STORAGE_CONSTANTS = {
  ADVANCED_SEARCH_FORMATTED_QUERY: 'advanceSearchFormattedQuery',
  ADVANCED_SEARCH_STRING_QUERY: 'advanceSearchString',
  LINKEDIN_PROFILE_UPLOAD_PATH : 'linkedinProfileUploadPath',
  LINKEDIN_PARSED_DATA: 'linkedInParsedData'
}
